import { IssueResolutionScope } from '../../typings/enums';
import { ResourceType } from '../../typings/permissions';

import { Category, CATEGORY_TO_ISSUE_TYPES, IssueScopeKind } from './common';

export const IssueResourceTypeToIssueTypes = Object.freeze({
  [ResourceType.ProjectLicensingIssue]: CATEGORY_TO_ISSUE_TYPES[Category.Licensing],
  [ResourceType.ProjectSecurityIssue]: CATEGORY_TO_ISSUE_TYPES[Category.Vulnerability],
  [ResourceType.ProjectQualityIssue]: CATEGORY_TO_ISSUE_TYPES[Category.Quality],

  [ResourceType.ReleaseGroupLicensingIssue]: CATEGORY_TO_ISSUE_TYPES[Category.Licensing],
  [ResourceType.ReleaseGroupSecurityIssue]: CATEGORY_TO_ISSUE_TYPES[Category.Vulnerability],
  [ResourceType.ReleaseGroupQualityIssue]: CATEGORY_TO_ISSUE_TYPES[Category.Quality],
});

export const CategoryToGlobalReleaseGroupIssueResourceType = Object.freeze({
  [Category.Licensing]: ResourceType.ReleaseGroupLicensingIssueAny,
  [Category.Vulnerability]: ResourceType.ReleaseGroupSecurityIssueAny,
  [Category.Quality]: ResourceType.ReleaseGroupQualityIssueAny,
});

export const CategoryToLocalReleaseGroupIssueResourceType = Object.freeze({
  [Category.Licensing]: ResourceType.ReleaseGroupLicensingIssue,
  [Category.Vulnerability]: ResourceType.ReleaseGroupSecurityIssue,
  [Category.Quality]: ResourceType.ReleaseGroupQualityIssue,
});

export const CategoryToGlobalProjectIssueResourceType = Object.freeze({
  [Category.Licensing]: ResourceType.ProjectLicensingIssueAny,
  [Category.Vulnerability]: ResourceType.ProjectSecurityIssueAny,
  [Category.Quality]: ResourceType.ProjectQualityIssueAny,
});

export const CategoryToLocalProjectIssueResourceType = Object.freeze({
  [Category.Licensing]: ResourceType.ProjectLicensingIssue,
  [Category.Vulnerability]: ResourceType.ProjectSecurityIssue,
  [Category.Quality]: ResourceType.ProjectQualityIssue,
});

// categoryToGlobalIssueResourceType returns the global ResourceType that applies to the given issue category.
export const categoryToGlobalIssueResourceType = (
  category: Category,
  scope: IssueResolutionScope | IssueScopeKind,
): ResourceType =>
  scope === IssueResolutionScope.ReleaseGroup || scope === IssueScopeKind.ReleaseGroup
    ? CategoryToGlobalReleaseGroupIssueResourceType[category]
    : CategoryToGlobalProjectIssueResourceType[category];

// categoryToLocalIssueResourceType returns the local ResourceType (i.e., scoped to a specific project or release group)
// that applies to the given issue category
export const categoryToLocalIssueResourceType = (
  category: Category,
  scope: IssueResolutionScope | IssueScopeKind,
): ResourceType =>
  scope === IssueResolutionScope.ReleaseGroup || scope === IssueScopeKind.ReleaseGroup
    ? CategoryToLocalReleaseGroupIssueResourceType[category]
    : CategoryToLocalProjectIssueResourceType[category];
